import React, { useEffect, useRef, useState } from "react";
import _, { template } from "lodash";
import * as d3 from "d3";
import { MatchScoreWidget } from "../../../../frontend/templates/_partials/MatchScoreWidget/Index";
import borderFrame from '../../../../frontend/templates/fcb/ResultsNew/images/border_BG.png'
import getContentById from "../../../utils/getContentById";
import { formatMinute, parseMinute, sortByTimeFirst } from "../../../../frontend/templates/fcb/ResultsNew/Index";
import TeamLogo from "../../../../frontend/templates/_partials/TeamLogo";
import assets from "../../../../frontend/templates/fcb/Heatmap/assets";
import anime from "animejs";
import { useTranslation } from "react-i18next";
require("../../../../frontend/templates/fcb/Heatmap/style/style.scss");


const renderHeatmap = (input, id, animation) => {
    const inputFake = input;

    $(`#heatmap-preview #heatmap-${id} svg`).remove();
    // IFAB regulations (105x68 meters)
    const margin = { top: 34, right: 44, bottom: 45, left: 50 },
        width = 891 - margin.left - margin.right,
        height = 577 - margin.top - margin.bottom;

    const svg = d3
        .select(`#heatmap-preview #heatmap-${id}`)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);
    // Add X axis
    const x = d3
        .scaleLinear()
        .domain([0, 100])
        .range([margin.left, width - margin.right]);
    svg.append("g").attr("transform", `translate(0, ${height})`);
    // .call(d3.axisBottom(x));

    // Add Y axis
    const y = d3
        .scaleLinear()
        .domain([0, 100])
        .range([height - margin.bottom, margin.top]);
    svg.append("g");
    // .call(d3.axisLeft(y));

    const color = d3
        .scaleLinear()
        .domain([0, 0.1, 0.15, 0.2, 0.3, 0.45, 0.65])
        .range(["lightgreen", "green", "yellow", "orange", "red", "darkred"]);

    // compute the density data
    const densityData = d3
        .contourDensity()
        .x(function (d) {
            return x(d.x);
        })
        .y(function (d) {
            return y(d.y);
        })
        .weight(100)
        .size([width, height])
        .bandwidth(15)
        .thresholds(15)
        .cellSize(1)(inputFake);
    // Add animation to draw the heatmap paths gradually

    const paths = svg
        .insert("g", "g")
        .selectAll("path")
        .data(densityData)
        .enter()
        .append("path")
        .attr("d", d3.geoPath())
        .attr("stroke", "transparent")
        .attr("stroke-width", 0)
        .attr("fill", function (d) {
            return color(d.value);
        });

    return {
        paths,
    };
};

const FCBHeatmapContent = ({ data, ...props }) => {
    const templateName = data?.template_name ?? "";
    const id = `${templateName}_${data?.uuid}`;
    const { options, fields, dynamic, editData } = data.data;
    const {
        matchInfo,
    } = data?.data?.dynamic;
    const [heatmapReturn, setHeatmapReturn] = useState();
    let heatmap = _.get(dynamic, "heatmap", []);
    const homeTeam = matchInfo?.contestant?.[0];
    const awayTeam = matchInfo?.contestant?.[1];
    const teamHeatmap = _.get(dynamic, "teamHeatmap");
    const playersData = getContentById(
        "heatmap_players",
        fields,
        'data',
    );
    const selectedPlayer = getContentById(
        "heatmap_players",
        fields,
    );
    const [heatmapData, setHeatmapData] = useState(heatmap);

    useEffect(() => {
        if (selectedPlayer) {
            const _heatmap = teamHeatmap?.filter(i => {
                return i.playerId === selectedPlayer;
            });
            setHeatmapData(_heatmap);
        } else {
            setHeatmapData([])
        }
    }, [selectedPlayer])

    const competitionId = matchInfo?.competition?.id;
    const playerHome = playersData?.find((p) => p.id === selectedPlayer);

    useEffect(() => {
        if (heatmapData.length) {
            const heatmapOut = renderHeatmap(heatmapData, id);
            setHeatmapReturn(heatmapOut);
        } else {
            $(`#heatmap-preview #heatmap-${id} svg`).remove();
        }
    }, [heatmapData]);

    useEffect(() => {
        if (heatmapReturn) {
            const { paths } = heatmapReturn;
            paths.each(function (d, i) {
                const path = d3.select(this);
                const totalLength = path.node().getTotalLength();

                path
                    .attr("stroke-dasharray", totalLength + " " + totalLength)
                    .attr("stroke-dashoffset", totalLength)
                    .attr("opacity", "1"); // Start with opacity 0
            })
        }
    }, [heatmapReturn]);
    const { t } = useTranslation();
    const selectedLang = data?.lang;

    return (
        <div className="T_fcb_heatmap" style={{ zIndex: 101, }}>
            <div className={"wc-content wc-content-v2"}
                style={{
                    transform: 'scale(0.41)',
                    left: -355,
                    color: 'white'
                }}
            >
                <div className={`${selectedLang === 'ar' ? "label-container-ar" : "label-container"}`}>
                    <div className="label-match-info-glow">{t("Heatmap", { keyPrefix: "templates", lng: selectedLang })}</div>
                    <div className="label-match-info">{t("Heatmap", { keyPrefix: "templates", lng: selectedLang })}</div>
                </div>
                <div className={"heatmap-block"}>
                    <div className={"pitch-container"}>
                        <div id={`heatmap-preview`}>
                            <div id={`heatmap-${id}`} className={`player-heatmap`}></div>
                        </div>
                        <img className={"heatmap-pitch"} src={assets.heatmap_pitch} />
                    </div>
                </div>
                <div className={"bottom-info-container"}>
                    <div className="team-logos-container">
                        <TeamLogo team={homeTeam} competitionId={competitionId} />
                        <TeamLogo team={awayTeam} competitionId={competitionId} />
                    </div>
                    <div className={`player-name`}>
                        {playerHome?.shortFirstName} {playerHome?.shortLastName}
                    </div>
                </div>
                <div className="gradient"></div>
            </div>
        </div>
    );
};

export default FCBHeatmapContent;
